import Icon from '../components/Icon.vue'

Icon.register({"school":{"width":640,"height":512,"paths":[{"d":"M0 224V496C0 504.8 7.2 512 16 512H96V192H32C14.3 192 0 206.3 0 224zM360 176H336V136C336 131.6 332.4 128 328 128H312C307.6 128 304 131.6 304 136V200C304 204.4 307.6 208 312 208H360C364.4 208 368 204.4 368 200V184C368 179.6 364.4 176 360 176zM497.8 112L337.8 5.4A32-32 0 0 1 302.3 5.4L142.3 112A32-32 0 0 1 128 138.7V512H256V368C256 359.2 263.2 352 272 352H368C376.8 352 384 359.2 384 368V512H512V138.7C512 128 506.6 118 497.8 112zM320 256C275.8 256 240 220.2 240 176S275.8 96 320 96 400 131.8 400 176 364.2 256 320 256zM608 192H544V512H624C632.8 512 640 504.8 640 496V224C640 206.3 625.7 192 608 192z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/school.js
// module id = Kxh+
// module chunks = 0